'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Link, _Pin, _CrehanaIso, _Clock, _Playsquare, _Deadline, _Calendar, _span, _Clock2;
import { forwardRef, lazy, Suspense } from 'react';
import Calendar from '@crehana/compass.icons.outline/Calendar';
import Clock from '@crehana/compass.icons.outline/Clock';
import Deadline from '@crehana/compass.icons.outline/Deadline';
import Link2 from '@crehana/compass.icons.outline/Link2';
import Pin from '@crehana/compass.icons.outline/Pin';
import Playsquare from '@crehana/compass.icons.outline/Playsquare';
import { cn, Tag } from '@crehana/compass.ui/v2';
import { formatDuration } from '@crehana/date';
import CrehanaIso from '@crehana/icons/logos/CrehanaIso';
import { useCollaboratorTranslation } from "../../hooks";
import { COURSE_LEVEL_ICON_MAP, DEFAULT_IMG_CONTENT } from "./constants";
import { buttonCardStyles } from "./CourseCard.styles";
import ContentTypeChip from "./ui/ContentTypeChip";
import CourseCover from "./ui/CourseCover";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var LazyPlayroomRewardIndicatorWithRive = /*#__PURE__*/lazy(function () {
  return import("../CardCoins").then(function (module) {
    return {
      "default": module["default"]
    };
  });
});
var CourseCard = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var title = _ref.title,
    level = _ref.level,
    style = _ref.style,
    duration = _ref.duration,
    durationTrack = _ref.durationTrack,
    className = _ref.className,
    sizeImage = _ref.sizeImage,
    coverImage = _ref.coverImage,
    contentType = _ref.contentType,
    expiresDate = _ref.expiresDate,
    isCrehanaCourse = _ref.isCrehanaCourse,
    isLiveSessionCourse = _ref.isLiveSessionCourse,
    typeLiveSession = _ref.typeLiveSession,
    dateSession = _ref.dateSession,
    hourSession = _ref.hourSession,
    _ref$coinsNumber = _ref.coinsNumber,
    coinsNumber = _ref$coinsNumber === void 0 ? 0 : _ref$coinsNumber,
    onClick = _ref.onClick,
    totalCourses = _ref.totalCourses,
    isRequired = _ref.isRequired;
  var _useCollaboratorTrans = useCollaboratorTranslation(),
    t = _useCollaboratorTrans.t;
  var formattedDuration = formatDuration(duration || durationTrack || 0);
  var shouldRenderCoins = coinsNumber > 0;
  var showDuration = !!duration && duration > 0 || !!durationTrack && durationTrack > 0;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
    _jsxs("article", {
      ref: ref,
      className: buttonCardStyles({
        className: className
      }),
      style: _objectSpread(_objectSpread({}, style), {}, {
        transition: 'border-color 0.3s ease'
      }),
      onClick: onClick,
      "aria-label": title,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "tw-w-full tw-min-h-min tw-mb-1.6",
        children: [/*#__PURE__*/_jsx(CourseCover, {
          title: title,
          coverImage: coverImage || DEFAULT_IMG_CONTENT,
          sizeImage: sizeImage
        }), isRequired && /*#__PURE__*/_jsx(Tag, {
          variant: "text",
          className: "tw-absolute tw-top-1.6 tw-left-1.2 tw-bg-neutral-light-800 tw-text-neutral-light-100",
          children: t('KH_REQUIRED')
        }), isLiveSessionCourse && /*#__PURE__*/_jsx("div", {
          className: "tw-absolute tw-top-1.6 tw-left-1.2 tw-flex tw-justify-between tw-items-center tw-gap-0.4 tw-rounded-[30px] tw-py-0.4 tw-px-1",
          style: {
            backgroundColor: 'rgba(255, 255, 255, 0.50)'
          },
          children: typeLiveSession === 'virtual' ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [_Link || (_Link = /*#__PURE__*/_jsx(Link2, {
              size: 16,
              className: "tw-text-neutral-light-100"
            })), /*#__PURE__*/_jsx("span", {
              className: "tw-font-subtitle5 tw-text-neutral-light-100",
              children: t('KH_VIRTUAL')
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [_Pin || (_Pin = /*#__PURE__*/_jsx(Pin, {
              size: 16,
              className: "tw-text-neutral-light-100"
            })), /*#__PURE__*/_jsx("span", {
              className: "tw-font-subtitle5 tw-text-neutral-light-100",
              children: t('KH_IN_PERSON')
            })]
          })
        })]
      }), isCrehanaCourse && (_CrehanaIso || (_CrehanaIso = /*#__PURE__*/_jsx(CrehanaIso, {
        size: 24,
        ignoreColor: true,
        className: "tw-fill-current tw-text-neutral-light-100 tw-absolute tw-left-0 tw-top-0 tw-m-2"
      }))), contentType && /*#__PURE__*/_jsx(ContentTypeChip, {
        contentType: contentType,
        className: "tw-mb-1 tw-mx-1.2"
      }), /*#__PURE__*/_jsxs("div", {
        className: cn('tw-w-full tw-mb-1 tw-min-h-3.2', shouldRenderCoins && 'tw-flex tw-items-start tw-justify-between'),
        children: [/*#__PURE__*/_jsx("h1", {
          className: "tw-font-subtitle5 tw-text-left tw-my-0 tw-mx-1.2 tw-select-text tw-line-clamp-2 dark:tw-text-neutral-light-100",
          children: title
        }), shouldRenderCoins && /*#__PURE__*/_jsx(Suspense, {
          fallback: null,
          children: /*#__PURE__*/_jsx(LazyPlayroomRewardIndicatorWithRive, {
            coins: coinsNumber,
            className: "tw-text-warning-500 tw-mr-1.6"
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-mt-auto tw-mx-1.2 tw-flex tw-items-center tw-mb-1.6 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500",
        children: [showDuration && /*#__PURE__*/_jsxs(_Fragment, {
          children: [_Clock || (_Clock = /*#__PURE__*/_jsx(Clock, {
            size: 16,
            className: "tw-inline-block tw-mr-0.4 tw-fill-current"
          })), /*#__PURE__*/_jsx("span", {
            className: "tw-font-body5 tw-select-all",
            children: formattedDuration
          })]
        }), level && /*#__PURE__*/_jsxs("div", {
          className: cn('tw-flex', {
            'tw-ml-1.2': showDuration
          }),
          children: [COURSE_LEVEL_ICON_MAP[level.toLowerCase()], /*#__PURE__*/_jsx("span", {
            className: "tw-font-body5 tw-mr-1.2 tw-select-all",
            children: level
          })]
        }), totalCourses && /*#__PURE__*/_jsxs("div", {
          className: cn('tw-flex tw-text-neutral-light-600 dark:tw-text-neutral-dark-500', {
            'tw-ml-1.2': showDuration
          }),
          children: [_Playsquare || (_Playsquare = /*#__PURE__*/_jsx(Playsquare, {
            size: 16,
            className: "tw-inline-block tw-mr-0.4 tw-fill-current"
          })), /*#__PURE__*/_jsx("span", {
            className: "tw-font-body5 tw-mr-1.2 tw-select-all",
            children: totalCourses
          })]
        })]
      }), expiresDate && /*#__PURE__*/_jsxs("div", {
        className: "dark:tw-text-secondary-dark-300 tw-text-primary-light-500 tw-font-body5 tw-mx-1.2 tw-flex tw-items-center tw-mt-1.2",
        children: [_Deadline || (_Deadline = /*#__PURE__*/_jsx(Deadline, {
          size: 16,
          className: "tw-text-current tw-mr-0.8"
        })), /*#__PURE__*/_jsx("span", {
          children: expiresDate
        })]
      }), isLiveSessionCourse && /*#__PURE__*/_jsxs("div", {
        className: "tw-w-full tw-flex tw-items-center tw-gap-0.8 tw-px-1.2 tw-text-neutral-light-700",
        children: [_Calendar || (_Calendar = /*#__PURE__*/_jsx(Calendar, {
          size: 16,
          className: "tw-text-inherit tw-flex-shrink-0"
        })), /*#__PURE__*/_jsx("span", {
          className: "tw-font-body5 tw-flex-shrink-0",
          children: dateSession
        }), _span || (_span = /*#__PURE__*/_jsx("span", {
          className: "tw-font-body5 tw-flex-shrink-0",
          children: '|'
        })), _Clock2 || (_Clock2 = /*#__PURE__*/_jsx(Clock, {
          size: 16,
          className: "tw-text-inherit tw-flex-shrink-0"
        })), /*#__PURE__*/_jsx("span", {
          className: "tw-font-body5 tw-flex-shrink-0",
          children: hourSession
        })]
      })]
    })
  );
});
CourseCard.displayName = 'CourseCard';
export default CourseCard;